import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ButtonSimple, ButtonSimpleNoColor } from '../form/button/ButtonSimple';

const Root = styled.div`
  background: #fff;
  padding: 1rem;
`;

const Message = styled.div`
  display: block;
  padding-bottom: 1rem;
`;

const ButtonPanel = styled.div`
  text-align: right;
`;

const ButtonDelete = styled(ButtonSimpleNoColor)`
  margin-right: 1rem;
`;

export const MessageDeleteCancel = (props: {
  text: string|ReactNode;
  onDelete: () => void;
  onCancel: () => void
}) => {
  const { text, onDelete, onCancel } = props;

  return (
    <Root>
      {typeof text === 'string' ? 
      <Message>{text}</Message> :
      text}
      <ButtonPanel>
        <ButtonDelete
          className="__primary-highlight-background-color __primary-highlight-foreground-color"
          onClick={onDelete}
        >
          Delete
        </ButtonDelete>
        <ButtonSimple onClick={onCancel}>Cancel</ButtonSimple>
      </ButtonPanel>
    </Root>
  );
};
